import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operator/debounceTime";
import { Subscription } from "rxjs/Subscription";
import { AccountService } from "./../../shared/account/account.service";
import { AuthService } from "../../shared/services/auth.service";
import { BackendService } from "../../shared/services/backend.service";
import { BillService } from "../../shared/bill/bill.service";

@Component({
  selector: "app-outstanding-bills",
  templateUrl: "./outstanding-bills.component.html",
  styleUrls: ["./outstanding-bills.component.scss"]
})
export class OutstandingBillsComponent implements OnInit, OnDestroy {
  private _alert = new Subject<string>();
  routeSubscription: Subscription = new Subscription();
  userId: string;
  communityId: string;
  page = 1;
  loading: true;
  activeRouteIndex = 0;
  outstandingLog = [];
  singleLog;
  modalReference: NgbModalRef;
  reminderMessage;
  formIsCollapsed = true;
  successMessage: string;
  errorMessage: string;
  subscription: Subscription;
  billService$: Subscription = new Subscription();
  order = "date";
  reverse = false;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private accountService: AccountService,
    private authService: AuthService,
    private billService: BillService
  ) {
    this.reminderMessage = "";
    this.userId = BackendService.generateUserId(this.authService.getAuthState().email);
  }

  ngOnInit(): void {
    this.routeSubscription = this.accountService.getProfile(this.userId)
    .subscribe((profile: any) => {
      this.route.params.subscribe(params => {
        this.activeRouteIndex = +params.index;
        const activeRole: any = profile.roles[this.activeRouteIndex];

        this.communityId = activeRole.communityId;

        this.billService$ = this.billService.getOutstandingBills(this.communityId).subscribe(data => {
          this.outstandingLog = data;
        });
      });
    });
  }

  viewLogDetails(log, modal): void {
    this.singleLog = log;
    this.open(modal);
  }

  sendReminder(): void {
    const messageObj = {
      message: this.reminderMessage,
      communityId: this.communityId,
      resident: this.singleLog.resident,
      operatorId: this.userId
    };

    this.billService.createBillReminder(messageObj).then(() => {
      this.close();
      this.showAlert(true, "Reminder sent successfully.");
      this.reminderMessage = "";
    }).catch(() => {
      this.showAlert(false, "Oops! An error occured. Please try again later.");
    });
  }

  open(modal): void {
    this.modalReference = this.modalService.open(modal);
  }

  close(): void {
    this.modalReference.close();
  }

  showAlert(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.successMessage = message)
          : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.successMessage = undefined)
            : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  setSortOrder(value: string): void {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  ngOnDestroy(): void {
    this.billService$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/outstanding-bills/outstanding-bills.component.ts